import * as React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@mui/material/CssBaseline";
import mapboxgl from "mapbox-gl";
import App from "./App";
import "mapbox-gl/dist/mapbox-gl.css";

// Fix mapbox-gl v2 production worker bundling with CRA/webpack 5
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default; // eslint-disable-line
import "./index.css";

import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
    <React.Fragment>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <App />
    </React.Fragment>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
